module.exports = __webpack_public_path__ + "assets/09c862db89d326439fe7387a3f5a3871.mp3";